import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "calificar-opinion" }
const _hoisted_2 = { class: "header-flex" }
const _hoisted_3 = { class: "header-acciones" }
const _hoisted_4 = {
  key: 0,
  class: "ctx-modelo"
}
const _hoisted_5 = {
  key: 1,
  class: "info"
}
const _hoisted_6 = {
  key: 2,
  class: "error"
}
const _hoisted_7 = {
  key: 3,
  class: "info"
}
const _hoisted_8 = {
  key: 4,
  class: "info"
}
const _hoisted_9 = {
  key: 0,
  class: "rubrica-inline",
  open: ""
}
const _hoisted_10 = {
  key: 0,
  class: "ctx-padres"
}
const _hoisted_11 = {
  key: 0,
  class: "ctx-ruta-tipo"
}
const _hoisted_12 = {
  key: 1,
  class: "ctx-ruta-ordinal"
}
const _hoisted_13 = { class: "ctx-ruta-nombre" }
const _hoisted_14 = { class: "aspecto-titulo" }
const _hoisted_15 = {
  key: 0,
  class: "ordinal"
}
const _hoisted_16 = { class: "indicador-header" }
const _hoisted_17 = { class: "promedio-chip" }
const _hoisted_18 = { class: "pregunta-enunciado" }
const _hoisted_19 = { class: "pregunta-meta" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 0,
  class: "pregunta-origen"
}
const _hoisted_23 = { class: "origen-chip" }
const _hoisted_24 = {
  key: 0,
  class: "origen-nota"
}
const _hoisted_25 = {
  key: 1,
  class: "origen-nota"
}
const _hoisted_26 = {
  key: 1,
  class: "nota-calculada"
}
const _hoisted_27 = { class: "nc-cab" }
const _hoisted_28 = { class: "nc-valor" }
const _hoisted_29 = { class: "nc-lbl" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 0,
  class: "nc-desglose"
}
const _hoisted_32 = { class: "nc-tabla" }
const _hoisted_33 = { class: "nc-formula" }
const _hoisted_34 = {
  key: 0,
  class: "nc-aviso"
}
const _hoisted_35 = {
  key: 1,
  class: "nc-sin"
}
const _hoisted_36 = {
  key: 2,
  class: "respuestas",
  open: ""
}
const _hoisted_37 = { class: "lista-distribucion" }
const _hoisted_38 = ["title"]
const _hoisted_39 = { class: "dist-barra" }
const _hoisted_40 = { class: "dist-pct" }
const _hoisted_41 = { class: "dist-cant" }
const _hoisted_42 = {
  key: 3,
  class: "sugerencias"
}
const _hoisted_43 = { class: "sug-nota" }
const _hoisted_44 = { class: "sug-detalle" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "campo-nota" }
const _hoisted_47 = ["for"]
const _hoisted_48 = ["id", "onUpdate:modelValue", "min", "max", "placeholder"]
const _hoisted_49 = { class: "form-group" }
const _hoisted_50 = { class: "botones" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = ["disabled"]

import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import useAutenticar from '@/store/IngresoAutenticar'
import type { CriterioEvaluacion } from '@/interfaces/CriterioEvaluacion'
import type { AspectoCalificable, IndicadorCalificable, PreguntaCalificable, DistribucionRespuesta } from '@/services/CalificacionOpinionPreguntaService'
import {
  getVistaCalificacionService,
  calificarPreguntasService
} from '@/services/CalificacionOpinionPreguntaService'
import { getProcesoByIdService } from '@/services/ProcesoAutoevaluacionService'
import { obtenerConfiguracionService } from '@/services/ConfiguracionInstrumentoService'
import { useComponentes } from '@/store/GestionComponentes'
import { useGestionTipoComponente } from '@/store/GestionTipoComponente'
import type Componente from '@/interfaces/Componente'
import RubricaVisorModal from '@/components/RubricaVisorModal.vue'
import RubricaTablaOpinion from '@/components/RubricaTablaOpinion.vue'
import MensajeFlotante from '@/components/MensajeFlotante.vue'

interface RutaNodo { tipo: string; ordinal: string; nombre: string }


export default /*@__PURE__*/_defineComponent({
  __name: 'CalificarInstrumentoOpinionView',
  setup(__props) {

/**
 * Calificación de un instrumento de opinión.
 *
 * En encuesta y grupo focal la nota se deriva automáticamente de la distribución
 * de respuestas; en taller o mesa de trabajo la pone el calificador.
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const route = useRoute()
const router = useRouter()
const auth = useAutenticar()
const componentesStore = useComponentes()
const tiposStore = useGestionTipoComponente()

const idConfiguracion = Number(route.params.id_configuracion)
const idEjecucion = route.query.id_ejecucion ? Number(route.query.id_ejecucion) : null
const nombreVersion = ref('')

function formatOrdinal(ordinal: string): string {
  if (!ordinal) return ''
  const parts = ordinal.split('.')
  return parts.length > 1 ? parts.slice(1).join('.') : ordinal
}

function buildRutaComponente(idComponente: number): RutaNodo[] {
  type NodoTemp = { idTipo: number | null | undefined; ordinal: string; nombre: string }
  const path: NodoTemp[] = []
  function buscar(nodos: Componente[], target: number, padres: NodoTemp[]): boolean {
    for (const n of nodos) {
      const nodoTemp: NodoTemp = { idTipo: n.id_tipo_componente, ordinal: formatOrdinal(n.ordinal ?? ''), nombre: n.nombre }
      if (n.id_componente === target) {
        padres.forEach(p => path.push(p))
        path.push(nodoTemp)
        return true
      }
      if (n.children?.length && buscar(n.children, target, [...padres, nodoTemp])) return true
    }
    return false
  }
  const raiz = componentesStore.componentes[0]
  if (raiz?.children) buscar(raiz.children, idComponente, [])
  return path.map(p => ({
    tipo: tiposStore.tipos.find(t => t.id_tipo_componente === p.idTipo)?.nombre ?? '',
    ordinal: p.ordinal,
    nombre: p.nombre
  }))
}

const escalaMax = computed<number>(() => {
  const raw = route.query.escala_max
  return Number(Array.isArray(raw) ? raw[0] : raw) || 5
})

const aspectos = ref<AspectoCalificable[]>([])
const esFormularioCompleto = ref(false)
const opcionesPorPregunta = ref<Record<number, string[]>>({})
const rubrica = ref<CriterioEvaluacion | null>(null)
const notas = ref<Record<number, number | null>>({})
const observaciones = ref('')
const cargando = ref(false)
const guardando = ref(false)
const error = ref('')
const verRubrica = ref(false)
const mensajeVisible = ref(false)
const mensajeTexto = ref('')
const mensajeTipo = ref<'positivo' | 'error'>('positivo')

function mostrarMensaje(texto: string, tipo: 'positivo' | 'error') {
  mensajeTexto.value = texto
  mensajeTipo.value = tipo
  mensajeVisible.value = true
}

const notasValidas = computed(() =>
  Object.entries(notas.value)
    .filter(([, v]) => v !== null && v !== undefined && !isNaN(Number(v)))
    .map(([id, v]) => ({ id_pregunta: Number(id), calificacion: Number(v) }))
)

const hayNotas = computed(() => notasValidas.value.length > 0)
const totalNotas = computed(() => notasValidas.value.length)

/** Promedio en vivo del indicador: es lo que se guardará para él. */
function promedioIndicador(ind: IndicadorCalificable): string | null {
  const valores = ind.preguntas
    .map(p => notas.value[p.id_pregunta])
    .filter(v => v !== null && v !== undefined && !isNaN(Number(v)))
    .map(v => Number(v))

  if (!valores.length) return null
  return (valores.reduce((a, b) => a + b, 0) / valores.length).toFixed(2)
}

function adoptar(pregunta: PreguntaCalificable, calificacion: number) {
  notas.value[pregunta.id_pregunta] = Number(calificacion)
}

/**
 * Para preguntas de escala numérica (1..escalaMax) completa los valores que
 * nadie eligió, añadiéndolos con cantidad=0 y porcentaje=0.
 * Para opciones de texto devuelve la distribución tal como llegó del backend.
 */
function distribucionCompleta(p: PreguntaCalificable): DistribucionRespuesta[] {
  const dist = p.respuestas.distribucion
  const todasOpciones = opcionesPorPregunta.value[p.id_pregunta]

  // Si el snapshot tiene la lista completa de opciones, usarla como base
  if (todasOpciones?.length) {
    const existentes = new Map(dist.map(d => [d.opcion, d]))
    return todasOpciones.map(op => existentes.get(op) ?? { opcion: op, cantidad: 0, porcentaje: 0 })
  }

  // Fallback para escala numérica: completar 1..escalaMax con 0
  if (!dist.length) return dist
  const sonNumericos = dist.every(d => d.opcion.trim() !== '' && !isNaN(Number(d.opcion)))
  if (!sonNumericos) return dist
  const existentesNum = new Map(dist.map(d => [Number(d.opcion), d]))
  const resultado: DistribucionRespuesta[] = []
  for (let i = 1; i <= escalaMax.value; i++) {
    resultado.push(existentesNum.get(i) ?? { opcion: String(i), cantidad: 0, porcentaje: 0 })
  }
  return resultado
}

async function cargar() {
  cargando.value = true
  error.value = ''
  try {
    if (idEjecucion) {
      const proceso = await getProcesoByIdService(idEjecucion)
      nombreVersion.value = (proceso as any)?.version?.nombre ?? ''
      const idVersion = proceso?.id_version
      if (idVersion) {
        const [raiz] = await Promise.all([
          componentesStore.cargarRaizPorVersion(idVersion),
          tiposStore.getTipos()
        ])
        if (raiz?.id_componente) await componentesStore.cargarArbolDesdeRaiz(raiz.id_componente)
      }
    }
    const [data, configResult] = await Promise.all([
      getVistaCalificacionService(idConfiguracion, idEjecucion),
      obtenerConfiguracionService(idConfiguracion)
    ])
    if (!data) {
      error.value = 'No se pudo cargar el instrumento.'
      return
    }
    // Construir mapa id_pregunta → opciones[] desde el snapshot de cada formulario
    if (configResult.ok && configResult.data) {
      const mapa: Record<number, string[]> = {}
      for (const formulario of configResult.data.formularios ?? []) {
        for (const snap of formulario.preguntas_snapshot ?? []) {
          if (snap.opciones?.length) mapa[snap.id_pregunta] = snap.opciones
        }
      }
      opcionesPorPregunta.value = mapa
    }
    esFormularioCompleto.value = data.modalidad === 'formulario_completo'
    aspectos.value = data.aspectos ?? []
    rubrica.value = data.rubrica ?? null
  } finally {
    cargando.value = false
  }
}

async function guardar() {
  if (!hayNotas.value) return

  const minVal = escalaMax.value > 5 ? 1 : 0
  const fueraDeRango = notasValidas.value.find(n => n.calificacion < minVal || n.calificacion > escalaMax.value)
  if (fueraDeRango) {
    mostrarMensaje(`Las calificaciones deben estar entre ${minVal} y ${escalaMax.value}.`, 'error')
    return
  }

  const idUsuario = auth.usuarioActual?.id
  if (!idUsuario) {
    mostrarMensaje('No se pudo identificar al usuario. Vuelva a iniciar sesión.', 'error')
    return
  }

  guardando.value = true
  try {
    const res = await calificarPreguntasService(idConfiguracion, {
      id_usuario: Number(idUsuario),
      id_ejecucion: idEjecucion,
      observaciones: observaciones.value || null,
      calificaciones: notasValidas.value
    })

    if (!res.ok) {
      mostrarMensaje(res.error ?? 'No se pudo calificar.', 'error')
      return
    }

    mensajeTexto.value = res.mensaje ?? 'Calificación registrada.'
    mensajeTipo.value = 'positivo'
    mensajeVisible.value = true
    setTimeout(() => router.back(), 1800)
  } finally {
    guardando.value = false
  }
}

onMounted(cargar)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("h1", null, "Calificar instrumento de opinión", -1)),
      _createElementVNode("div", _hoisted_3, [
        (rubrica.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn salir",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (verRubrica.value = true))
            }, "Ver rúbrica"))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "btn salir",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
        }, "Salir")
      ])
    ]),
    _cache[12] || (_cache[12] = _createElementVNode("p", { class: "subtitulo" }, " Cada pregunta califica su propio aspecto. La nota de un indicador es el promedio de sus preguntas. ", -1)),
    (nombreVersion.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(nombreVersion.value), 1))
      : _createCommentVNode("", true),
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "divider" }, null, -1)),
    (cargando.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Cargando…"))
      : (error.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(error.value), 1))
        : (esFormularioCompleto.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Este formulario califica como una sola unidad: su nota se registra desde la ficha de opinión, sobre el formulario completo, no pregunta por pregunta. "))
          : (!aspectos.value.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Este instrumento no tiene preguntas con indicador asignado. "))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                (rubrica.value)
                  ? (_openBlock(), _createElementBlock("details", _hoisted_9, [
                      _cache[7] || (_cache[7] = _createElementVNode("summary", null, "Rúbrica de opinión — tabla de valoración", -1)),
                      _createVNode(RubricaTablaOpinion, {
                        rubrica: rubrica.value.criterio
                      }, null, 8, ["rubrica"])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aspectos.value, (aspecto) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: aspecto.id_componente ?? aspecto.aspecto,
                    class: "aspecto"
                  }, [
                    (aspecto.id_componente)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buildRutaComponente(aspecto.id_componente).slice(0, -1), (nodo, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: i,
                              class: "ctx-ruta-nodo"
                            }, [
                              (nodo.tipo)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(nodo.tipo), 1))
                                : _createCommentVNode("", true),
                              (nodo.ordinal)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(nodo.ordinal), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_13, _toDisplayString(nodo.nombre), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("h3", _hoisted_14, [
                      (aspecto.id_componente && buildRutaComponente(aspecto.id_componente).at(-1)?.ordinal)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(buildRutaComponente(aspecto.id_componente!).at(-1)!.ordinal), 1))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(aspecto.aspecto), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aspecto.indicadores, (ind) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: ind.id_indicador,
                        class: "indicador"
                      }, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("strong", null, _toDisplayString(ind.indicador), 1),
                          _createElementVNode("span", _hoisted_17, " Promedio: " + _toDisplayString(promedioIndicador(ind) ?? '—'), 1)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ind.preguntas, (p) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: p.id_pregunta,
                            class: "pregunta-card"
                          }, [
                            _createElementVNode("p", _hoisted_18, _toDisplayString(p.enunciado), 1),
                            _createElementVNode("p", _hoisted_19, [
                              (p.grupo_interes)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(p.grupo_interes) + " · ", 1))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(p.respuestas.total) + " respuesta(s) ", 1),
                              (p.respuestas.promedio != null)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, " · promedio de respuestas " + _toDisplayString(Number(p.respuestas.promedio).toFixed(2)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            (p.formulario)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
                                  _createElementVNode("span", _hoisted_23, _toDisplayString(p.formulario.titulo || p.formulario.instrumento || 'Formulario'), 1),
                                  (p.formulario.general)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, "pregunta general (va en todos los formularios)"))
                                    : (p.formulario.grupo_interes)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, " formulario de " + _toDisplayString(p.formulario.grupo_interes), 1))
                                      : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (p.nota_sugerida)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                  (p.nota_sugerida.nota != null)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("div", _hoisted_27, [
                                          _createElementVNode("span", _hoisted_28, _toDisplayString(p.nota_sugerida.nota.toFixed(2)), 1),
                                          _createElementVNode("span", _hoisted_29, " Nota calculada · " + _toDisplayString(p.nota_sugerida.desglose?.porcentaje_cumplimiento?.toFixed(2)) + "% de cumplimiento ", 1),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-sm guardar",
                                            onClick: ($event: any) => (adoptar(p, p.nota_sugerida.nota))
                                          }, " Usar esta nota ", 8, _hoisted_30)
                                        ]),
                                        (p.nota_sugerida.desglose)
                                          ? (_openBlock(), _createElementBlock("details", _hoisted_31, [
                                              _cache[9] || (_cache[9] = _createElementVNode("summary", null, "Ver cómo se calculó", -1)),
                                              _createElementVNode("table", _hoisted_32, [
                                                _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
                                                  _createElementVNode("tr", null, [
                                                    _createElementVNode("th", null, "Opción"),
                                                    _createElementVNode("th", null, "Respuestas"),
                                                    _createElementVNode("th", null, "Puntos c/u"),
                                                    _createElementVNode("th", null, "Subtotal")
                                                  ])
                                                ], -1)),
                                                _createElementVNode("tbody", null, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.nota_sugerida.desglose.conteo, (c, i) => {
                                                    return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                                      _createElementVNode("td", null, _toDisplayString(c.opcion), 1),
                                                      _createElementVNode("td", null, _toDisplayString(c.cantidad), 1),
                                                      _createElementVNode("td", null, _toDisplayString(c.puntos_por_respuesta), 1),
                                                      _createElementVNode("td", null, _toDisplayString(c.subtotal.toFixed(2)), 1)
                                                    ]))
                                                  }), 128))
                                                ])
                                              ]),
                                              _createElementVNode("p", _hoisted_33, [
                                                _createTextVNode(_toDisplayString(p.nota_sugerida.desglose.puntaje_apreciado.toFixed(2)) + " ÷ " + _toDisplayString(p.nota_sugerida.desglose.puntaje_total.toFixed(2)) + " × 100 = ", 1),
                                                _createElementVNode("b", null, _toDisplayString(p.nota_sugerida.desglose.porcentaje_cumplimiento.toFixed(2)) + "%", 1),
                                                _createTextVNode(" → × " + _toDisplayString(p.nota_sugerida.desglose.escala_max) + " ÷ 100 = ", 1),
                                                _createElementVNode("b", null, _toDisplayString(p.nota_sugerida.nota.toFixed(2)), 1)
                                              ]),
                                              (p.nota_sugerida.desglose.opciones_no_reconocidas.length)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_34, " No se contaron (no están en la tabla de valoración): " + _toDisplayString(p.nota_sugerida.desglose.opciones_no_reconocidas.join(', ')), 1))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : (p.nota_sugerida.motivo)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(p.nota_sugerida.motivo), 1))
                                      : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (p.respuestas.distribucion?.length)
                              ? (_openBlock(), _createElementBlock("details", _hoisted_36, [
                                  _createElementVNode("summary", null, "Distribución de respuestas (" + _toDisplayString(p.respuestas.total) + " resp.)", 1),
                                  _createElementVNode("ul", _hoisted_37, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(distribucionCompleta(p), (d, i) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: i,
                                        class: _normalizeClass(['fila-dist', { 'fila-dist--vacia': d.cantidad === 0 }])
                                      }, [
                                        _createElementVNode("span", {
                                          class: "dist-opcion",
                                          title: d.opcion
                                        }, _toDisplayString(d.opcion), 9, _hoisted_38),
                                        _createElementVNode("span", _hoisted_39, [
                                          _createElementVNode("span", {
                                            class: "dist-relleno",
                                            style: _normalizeStyle({ width: `${d.porcentaje}%` })
                                          }, null, 4)
                                        ]),
                                        _createElementVNode("span", _hoisted_40, _toDisplayString(d.porcentaje) + "%", 1),
                                        _createElementVNode("span", _hoisted_41, _toDisplayString(d.cantidad === 0 ? 'Sin respuestas' : `(${d.cantidad})`), 1)
                                      ], 2))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (p.sugerencias.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                  _cache[10] || (_cache[10] = _createElementVNode("p", { class: "sugerencia-titulo" }, " Ya se calificó esta pregunta para este aspecto: ", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.sugerencias, (s) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: s.id,
                                      class: "sugerencia"
                                    }, [
                                      _createElementVNode("span", _hoisted_43, _toDisplayString(Number(s.calificacion).toFixed(2)), 1),
                                      _createElementVNode("span", _hoisted_44, [
                                        _createTextVNode(_toDisplayString(s.periodo ? `periodo ${s.periodo}` : 'sin periodo') + " · " + _toDisplayString(s.total_respuestas) + " respuesta(s) ", 1),
                                        (s.calificado_por)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode(" · " + _toDisplayString(s.calificado_por), 1)
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-sm guardar",
                                        onClick: ($event: any) => (adoptar(p, s.calificacion))
                                      }, " Usar esta nota ", 8, _hoisted_45)
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_46, [
                              _createElementVNode("label", {
                                for: `nota-${p.id_pregunta}`
                              }, "Calificación (" + _toDisplayString(escalaMax.value > 5 ? `1 – ${escalaMax.value}` : `0 – ${escalaMax.value}`) + ")", 9, _hoisted_47),
                              _withDirectives(_createElementVNode("input", {
                                id: `nota-${p.id_pregunta}`,
                                "onUpdate:modelValue": ($event: any) => ((notas.value[p.id_pregunta]) = $event),
                                type: "number",
                                min: escalaMax.value > 5 ? 1 : 0,
                                max: escalaMax.value,
                                step: "0.1",
                                class: "input-nota",
                                placeholder: escalaMax.value > 5 ? `1 - ${escalaMax.value}` : `0 - ${escalaMax.value}`
                              }, null, 8, _hoisted_48), [
                                [
                                  _vModelText,
                                  notas.value[p.id_pregunta],
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
                    }), 128))
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_49, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", { for: "obs" }, "Observaciones", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    id: "obs",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((observaciones).value = $event)),
                    rows: "2",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, observaciones.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("button", {
                    class: "btn salir",
                    disabled: guardando.value,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.back()))
                  }, "Cancelar", 8, _hoisted_51),
                  _createElementVNode("button", {
                    class: "btn guardar",
                    disabled: guardando.value || !hayNotas.value,
                    onClick: guardar
                  }, _toDisplayString(guardando.value ? 'Guardando…' : `Calificar ${totalNotas.value || ''}`.trim()), 9, _hoisted_52)
                ])
              ], 64)),
    _createVNode(RubricaVisorModal, {
      visible: verRubrica.value,
      criterio: rubrica.value,
      onCerrar: _cache[4] || (_cache[4] = ($event: any) => (verRubrica.value = false))
    }, null, 8, ["visible", "criterio"]),
    _createVNode(MensajeFlotante, {
      visible: mensajeVisible.value,
      mensaje: mensajeTexto.value,
      tipo: mensajeTipo.value,
      onCerrar: _cache[5] || (_cache[5] = ($event: any) => (mensajeVisible.value = false))
    }, null, 8, ["visible", "mensaje", "tipo"])
  ]))
}
}

})